export const pageInfo = {
  title: "Enerflo – Complete FAQ for Solar Companies",
  subheading:
    "Answers to the most common questions about Enerflo’s all-in-one solar operations platform, features, pricing, and partner benefits.",
};
